import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SnAuthorizedGuard } from '@lib/auth';

import { FmRoomGuard, FmJwtGuard } from './guards';

const routes: Routes = [
  {
    path: '',
    canActivate: [FmRoomGuard],
    loadChildren: () => import('@app/fusus-meet/public').then((m) => m.FmPublicModule),
  },
  {
    path: 'main',
    canActivate: [FmJwtGuard, SnAuthorizedGuard],
    loadChildren: () => import('@app/fusus-meet/main').then((m) => m.MainModule),
  },
  {
    path: 'meet-ended',
    loadChildren: () => import('@app/fusus-meet/meet-ended').then((m) => m.FmMeetEndedModule),
  },
  {
    path: '**',
    redirectTo: 'main',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
